import { render, staticRenderFns } from "./AddJudgeForm.vue?vue&type=template&id=4c5852d4&scoped=true"
import script from "./AddJudgeForm.vue?vue&type=script&lang=ts"
export * from "./AddJudgeForm.vue?vue&type=script&lang=ts"
import style0 from "./AddJudgeForm.vue?vue&type=style&index=0&id=4c5852d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5852d4",
  null
  
)

export default component.exports